var poll_default = {
  "fontElementMap": "_70Don",
  "container": "_5SjlT",
  "fullscreen": "Uu94V",
  "background_overlay": "mcr4P",
  "with_image": "x4QT-",
  "options": "XB5Ut",
  "webview": "I579C",
  "grid": "_857af",
  "option": "CpNzX",
  "cta_button": "Bgj2a",
  "add_option": "h3A3I",
  "see_more": "RtG6U",
  "list": "uhQ8D",
  "column": "wR6xY",
  "additional_note": "EMIE3",
  "spinner": "J4PyZ",
  "spin": "laHfO",
  "shown": "puF1K",
  "error": "okPYP"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
